// extracted by mini-css-extract-plugin
module.exports = {"list":"placesList_list__a5x_x","error":"placesList_error__gM66k"};